import { render, staticRenderFns } from "./PhoneLogin.vue?vue&type=template&id=8cefe67e&scoped=true&"
import script from "./PhoneLogin.vue?vue&type=script&lang=js&"
export * from "./PhoneLogin.vue?vue&type=script&lang=js&"
import style0 from "./PhoneLogin.vue?vue&type=style&index=0&id=8cefe67e&lang=less&scoped=true&"
import style1 from "./PhoneLogin.vue?vue&type=style&index=1&id=8cefe67e&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cefe67e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cefe67e')) {
      api.createRecord('8cefe67e', component.options)
    } else {
      api.reload('8cefe67e', component.options)
    }
    module.hot.accept("./PhoneLogin.vue?vue&type=template&id=8cefe67e&scoped=true&", function () {
      api.rerender('8cefe67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login/comp/PhoneLogin.vue"
export default component.exports